import { headerCase } from 'change-case';

/**
 * Dynamically build the form data to upload the provided file to the provided presigned post URL
 * @param presignedPostFields object containing the signature fields to upload the file
 * @param file
 * @returns FormData
 */
export const buildFileUploadForm = (presignedPostFields: Record<string, string>, file: File) => {
  const formData = new FormData();
  formData.append('Content-Type', file.type);
  Object.entries(presignedPostFields).forEach(([key, value]) => {
    if (key !== '__typename') {
      // change headers format to dash-case again (graphql doesn't support dashes)
      formData.append(headerCase(key), value);
    }
  });
  formData.append('file', file);

  return formData;
};
